/**
   * @ngdoc service
   * @name adjust.service:Loading
   *
   * @description
   * Loading service for the {@link adjust.directive:loading loading loading} directive
   *
   */
function Loading() {
  'ngInject';
  /**
   * @ngdoc property
   * @name _instances
   * @propertyOf adjust.service:Loading
   *
   * @description
   * Number of instances
   *
   * @type {number}
   * @private
   */
  var _instances = 0;


  return {
    register: register
  };

  /**
   * @ngdoc method
   * @name register
   * @methodOf adjust.service:Loading
   *
   * @description
   * Register new loading instance and return total number which is used as identifier
   *
   * @returns {number} current number of instances
   */
  function register() {

    _instances += 1;

    return _instances;

  }
}

export { Loading };
